export default __webpack_public_path__ + "assets/images/responsible-gaming-633b9588c696aa5888e8bfa97472d3f6.svg";